import axios from '../../config/axios';

export function getAccounts(params) {
    return axios().get(`/stock-journal/account`, { params })
}

function search(query) {
    return axios().get(`/stock-journal/account-search`, { params: {
        search: query
    } })    
}

export default {
    search
}